export default {
  agricultureCategory: '/agriculture/category',
  agricultureType: '/agriculture/type',
  agricultureName: '/agriculture/name',
  agricultureDetails: '/agriculture/details',
  AgricultureAnalytics: '/agriculture/analytics',
  AgricultureGroup: '/agriculture-group',
}
